export const ANALYTICS_EVENTS = {
  PAGE_VIEW: "page_view",
  IDENTIFY: "identify",
  PRODUCT_LIST_VIEWED: "Product List Viewed",
  PRODUCT_CLICKED: "Product Clicked",
  PRODUCT_ADDED: "Product Added",
  PRODUCT_VIEWED: "Product Viewed",
  PRODUCT_NOTIFICATION_REQUESTED: "Product Notification Requested",
  PRODUCT_NOTIFICATION_REQUESTED_FROM_CARD:
    "Product Notification Requested From Card",
  SEE_OPTIONS: "See Options",
  ADD_TO_CART: "Add to Cart",
  PRODUCT_REMOVED: "Product Removed",
  CART_VIEWED: "Cart Viewed",
  EXPERIMENT_VIEWED: "Experiment Viewed",
  BUTTON_CLICKED: "Button Clicked",
  SUBSCRIBE_FORM_SUBMITTED: "Subscribe Form Submitted",
  BOOKING_GET_TICKETS: "Booking Get Tickets",
  PRODUCTS_SEARCHED: "Products Searched",
  CART_SAVED: "Cart Saved",
  VIDEO_CLICKED: "Video Clicked",
  CARD_CLICKED: "Card Clicked",
  IMAGE_CLICKED: "Image Clicked",
  KLAVIYO_FORM_OPENED: "Klaviyo Form Opened",
  KLAVIYO_FORM_EMBED_OPENED: "Klaviyo Form Embed Opened",
  KLAVIYO_FORM_CLOSED: "Klaviyo Form Closed",
  KLAVIYO_FORM_SUBMITTED: "Klaviyo Form Submitted",
  TIME_SLOT_SELECTED: "Time Slot Selected",
  TICKET_QUANTITY_SELECTED: "Ticket Quantity Selected",
  LOCATION_SELECTED: "Location Selected",
  DATE_SELECTED: "Date Selected",
  BOOKING_ADDON_SCREEN_LOADED: "Booking Addon Screen Loaded",
  BOOKING_CONTINUE_TO_CHECKOUT: "Booking Continue to Checkout",
  BOOKING_SCHEDULE_SCREEN_LOADED: "Booking Schedule Screen Loaded",
  BOOKING_TICKET_QUANTITY_SCREEN_LOADED:
    "Booking Ticket Quantity Screen Loaded",
  BOOKING_RESERVE_YOUR_TICKETS: "Booking Reserve Your Tickets",
  BOOKING_RESERVATION_REQUEST_EXPIRED: "Booking Reservation Request Expired",
  ADD_ON_SELECTED: "Add-On Selected",
  LINK_CLICKED: "Link Clicked"
} as const

export type AnalyticsEventName =
  (typeof ANALYTICS_EVENTS)[keyof typeof ANALYTICS_EVENTS]
